import { render } from "./EmailStepThree.vue?vue&type=template&id=22f1a218&scoped=true"
import script from "./EmailStepThree.vue?vue&type=script&lang=js"
export * from "./EmailStepThree.vue?vue&type=script&lang=js"

import "./EmailStepThree.vue?vue&type=style&index=0&id=22f1a218&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-22f1a218"

export default script